import { Box, Button, Stack, Typography } from "@mui/material";
import { useDarkMode } from "../../../contexts/useDarkModeContext";

function ReadyToTakeSection() {
  return (
    <Stack
      sx={{
        bgcolor: "#F4F4F4",
        py: "80px",
        px: "150px",
        position: "relative",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: "700",
          fontSize: "62px",
          lineHeight: "70px",
          fontFamily: "Inter",
          color: "#000000",
          maxWidth: "697px",
        }}
      >
        Ready to take the next step in your career?
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontWeight: "400",
          fontSize: "18px",
          lineHeight: "26px",
          fontFamily: "Inter",
          color: "#000000",
          maxWidth: "697px",
          pt: "26px",
        }}
      >
        Join JobLinkup today and start exploring exciting job opportunities with
        top companies.
      </Typography>
      <Stack direction="row" sx={{ pt: "45px", gap: "18px" }}>
        <Button
          variant="contained"
          sx={{
            borderRadius: "46px",
            px: "26px",
            minWidth: "auto",
            width: "auto",
            textTransform: "none",
            bgcolor: "#000000",
            color: "#ffffff",
            boxShadow: "none",
            py: "14px",
            fontSize: "20px",
            lineHeight: "30px",
            fontFamily: "Inter",
            fontWeight: "500",
          }}
        >
          Contact Us
        </Button>
        <Button
          variant="contained"
          sx={{
            borderRadius: "41px",
            px: "26px",
            minWidth: "auto",
            width: "auto",
            textTransform: "none",
            bgcolor: "transparent",
            color: "#000000",
            boxShadow: "none",
            py: "14px",
            fontSize: "20px",
            lineHeight: "30px",
            fontFamily: "Inter",
            fontWeight: "500",
            border: "1px solid #000000",
          }}
        >
          Learn More
        </Button>
      </Stack>
      <Box
        component="img"
        src="/icons/readyToTakePlusIcon.svg"
        sx={{
          width: 40,
          height: 40,
          position: "absolute",
          bottom: 85,
          right: 680,
        }}
      ></Box>
      <Box
        component="img"
        src="/icons/readyToTakePlusIcon.svg"
        sx={{
          width: 40,
          height: 40,
          position: "absolute",
          top: 176,
          right: 160,
        }}
      ></Box>
    </Stack>
  );
}

export default ReadyToTakeSection;
